import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { gql } from '../../utils/gqlClient';
import { wrapQuery } from '../../utils/wrapQuery';
import { getResetPasswordRedirect } from '../../utils/config';
export { sendResetPasswordEmail };
var sendResetPasswordEmailMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query SendResetPasswordEmail($clientId: String!, $email: String!, $redirect: String) {\n    sendResetPasswordEmail(clientId: $clientId, email: $email, redirect: $redirect) {\n      status\n      token\n    }\n  }\n"])));
function sendResetPasswordEmail(_x, _x2) {
  return _sendResetPasswordEmail.apply(this, arguments);
}
function _sendResetPasswordEmail() {
  _sendResetPasswordEmail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(clientId, email) {
    var data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return wrapQuery('sendResetPasswordEmail', sendResetPasswordEmailMutation, {
            clientId: clientId,
            email: email,
            redirect: getResetPasswordRedirect()
          });
        case 2:
          data = _context.sent;
          return _context.abrupt("return", data.sendResetPasswordEmail);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _sendResetPasswordEmail.apply(this, arguments);
}